<template>
    <div class="tableComponent w-full" :class="{'tHeader': tHeader}" ref="tables">
        <vs-table
            ref="table"
            :hoverFlat="hoverFlat"
            :stripe="stripe"
            :pagination="pagination"
            :max-items="lengthItems"
            :search="pagination"
            :data="tableData"
            :noDataText="i('table.No_data_available')"
        >
            <div slot="header" v-if="pagination" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <div class="flex items-center data-list-btn-container header mb-4 justify-between offers__buttons w-full">
                    <slot name="header"></slot>

                    <div class="flex items-center justify-between w-full">
                        <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 items-per-page-handler">
                            <div
                                class="p-4 border border-solid flex d-theme-border-grey-light rounded-full flex-grow d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                                <span class="mr-2 whitespace-no-wrap">
                                    {{currentPage() * lengthItems - (lengthItems - 1)}} - {{tableData.length - currentPage() * lengthItems > 0 ? currentPage() * lengthItems : tableData.length}} of {{ lengthData }}
                                </span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item v-for="(p, index) of paginationWatch" :key="index" @click="lengthItems=p">
                                    <span>{{p}}</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                        <div class="flex items-center">
                            <vs-input icon-pack="feather" icon="icon-search" :placeholder="i('global.Search')" v-model="searchInput" class="search is-label-placeholder w-full mr-4" />
                            <vs-pagination
                                color="primary"
                                @input="changePagination"
                                ref="paginatin"
                                :max="refPaginationPagesLength < 9 ? refPaginationPagesLength : 9"
                                v-model="getCurrenPage"
                                :total="getTotalPages"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <template slot="thead">
                <slot name="head"></slot>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <template v-for="(tr, index) in data">
                    <vs-tr :key="index">
                        <slot name="content" v-bind:content="tr"></slot>

                        <template v-if="details" slot="expand">
                            <slot name="details" v-bind:details="tr"></slot>
                        </template>
                    </vs-tr>
                    <vs-tr v-if="!stripe" class="spacer" :key="index + '-list'">
                        <vs-td colspan="9"></vs-td>
                    </vs-tr>
                </template>
                </tbody>
            </template>
        </vs-table>
        <vs-pagination
            v-if="pagination"
            color="primary"
            ref="paginatin2"
            @input="changePagination"
            :max="refPaginationPagesLength < 9 ? refPaginationPagesLength : 9"
            v-model="getCurrenPage"
            :total="getTotalPages"
        />
    </div>
</template>

<script>
import i18n from '@/i18n/i18n'
import {fixHindusPagination} from '@/utils/mixins'
export default {
    mixins: [fixHindusPagination],
    data() {
        return {
            searchInput: '',
            getCurrenPage: 1,
            getTotalPages: 1,
            lengthData: 1,
            lengthItems: this.maxItems,
            refPaginationPagesLength: 0
        }
    },

    props: {
        tableData: { type: Array, required: true },
        maxItems: { type: Number, default: 10 },
        details: { type: Boolean, default: false },
        stripe: { type: Boolean, default: false },
        hoverFlat: { type: Boolean, default: false },
        pagination: {type: Boolean, default: true},
        paginationWatch: { type: Array, default: () => {
                return [10, 15, 20]
            }},
        dataForSearch: {
            type: String,
            default: ''
        },
        tHeader: { type: Boolean, default: false },
        additionallyCheckByDomains: {
            type: Array,
            default(){
                return []
            }
        }
    },

    watch: {
        tableData(val) {
            if (val && Array.isArray(val)) {
                val.length ? this.getCurrenPage = 1 : this.getCurrenPage
            }
        },
        dataForSearch(val){
            if (val) {
                this.searchInput = val
            }
        },
        searchInput(val) {
            const foundDomain = this.additionallyCheckByDomains.length ? this.additionallyCheckByDomains.find(domain => domain && domain.label === val) : null;

            if (foundDomain){
                const foundDomainInTable = this.tableData.some(data => {
                    if (data.domains){
                        return data.domains.some(el => el === foundDomain.value)
                    }
                })

                foundDomainInTable ?  this.$emit('foundDomain', foundDomain.value) :  this.$refs.table.searchx = val
            } else {
                this.$emit('foundDomain', false)
                this.$refs.table.searchx = val
            }

            this.fixHinduCloseExpand()
        }
    },

    methods: {
        changePagination() {
            this.$refs.table.currentx = this.$refs.paginatin.current
        },

        currentPage() {
            if (this.$refs.table) {
                return this.$refs.table.currentx
            }
            return 1
        },

        i(val) {
            return i18n.tc(val)
        },

        fixHinduCloseExpand() {
            const expand = [...document.querySelectorAll('tr.tr-expand')];
            if (expand.length) {
                expand.map(element => element.remove())

                this.$refs.table.$children.forEach(item => {
                    if(item.expanded) {
                        item.expanded = false
                    }
                })

                const parentExpand = [...document.querySelectorAll('.tr-expandedx')];

                if (parentExpand.length) {
                    parentExpand.map(element => element.classList.remove('tr-expandedx'));
                }
            }
        }
    },

    updated() {
        this.getCurrenPage = this.$refs.table.currentx
        this.getTotalPages = this.$refs.table.getTotalPagesSearch
        this.lengthData = this.$refs.table.queriedResults.length

        this.$watch(
            () => {
                return this.$refs.table.getTotalPagesSearch
            },
            val => {
                this.getTotalPages = val;
            }
        )
    },

    mounted() {
        this.$watch(
            () => {
                if (this.$refs.paginatin) {
                    return this.$refs.paginatin.pages
                }
            },
            value => {
                if (value) {
                    this.$set(this, 'refPaginationPagesLength', value[value.length -1])
                    Object.assign(this.$refs.paginatin, {getPages: this.getPages(this.$refs.paginatin)})
                    Object.assign(this.$refs.paginatin2, {getPages: this.getPages(this.$refs.paginatin2)})
                    this.fixHinduCloseExpand()
                }
            }
        )
        this.getTotalPages = this.$refs.table.getTotalPagesSearch
    }
}
</script>

<style lang="scss">
.tableComponent {
    .con-pagination-table {
        display: none;
    }
    .search input {
        border-radius: 50px;
    }

    .vs-con-table .vs-table--header .vs-table--search {
        display: none !important;
    }

    .vs-pagination--ul {
        li {
            font-size: .8rem;
            width: 30px;
            height: 30px;
        }
    }

    .td-check {
        width: 40px;
    }

    // .tr-expand {
    //     td {
    //         padding: 0;
    //     }
    // }
}

.tHeader {
    .vs-table--thead tr {
        background: none;
    }

    // .vs-table {
    //     &-text {
    //         text-transform: uppercase;
    //     }
    //     &--tbody-table {
    //         tr {
    //             &.spacer {
    //                 background: none;
    //                 box-shadow: none;

    //                 td {
    //                     padding: 5px !important;
    //                 }
    //             }

    //             td {
    //                 &:first-child {
    //                     border-top-left-radius: .5rem;
    //                     border-bottom-left-radius: .5rem;

    //                     &.td-check {
    //                         max-width: 30px;
    //                         padding: 20px 0 20px 15px !important;
    //                     }
    //                 }

    //                 &:last-child {
    //                     border-top-right-radius: .5rem;
    //                     border-bottom-right-radius: .5rem;
    //                 }

    //                 .vs-button.small {
    //                     padding: 0.5rem 1rem;

    //                     &.includeIcon {
    //                         padding: 0.5rem 1rem 0.5rem 0.7rem;
    //                     }
    //                 }
    //             }
    //         }
    //     }
    // }
}
</style>
